module.exports = __webpack_public_path__ + "static/media/IconTxnGroupSuccess.1c3c0661.svg";